import {Controller} from "@hotwired/stimulus";

// Checkout form: show the bank details for private payment and the matching
// billing address block for company / practice payment. Attached to the form
// itself (guests/_form, users/_show_for_cart).
//
// Ported 1:1 from companyPaymentSelected() in the sprockets carts.js, minus its
// dead `.cart-address-private` selector, which no view renders.
export default class extends Controller {
    connect() {
        // the guest form leaves its inputs enabled server-side, so the initial
        // disabled state has to be applied here; the user form is rendered disabled
        const checked = this.element.querySelector('input[name="guest[payment_type]"]:checked');
        if (checked) this.apply(checked.value);
    }

    // the action sits on the form, so every field change lands here
    select(event) {
        if (!/\[payment_type\]$/.test(event.target.name || "")) return;
        this.apply(event.target.value);
    }

    apply(value) {
        this.toggle(".bank-data", value !== "private");
        this.toggle(".company-payment", value === "private");
        this.element.querySelectorAll(".cart-address").forEach((el) => el.classList.add("hide"));
        this.toggle(".cart-address-company", value !== "company");
        this.toggle(".cart-address-practice", value !== "practice");

        // guests only - the user form ships every field disabled by default
        if (!this.element.querySelector('input[name^="guest"]')) return;
        this.disable(".cart-address-company input, .cart-address-company select", value !== "company");
        this.disable(".cart-address-practice input, .cart-address-practice select", value !== "practice");
        this.disable(".bank-data input", value !== "private");
    }

    toggle(selector, hidden) {
        this.element.querySelectorAll(selector).forEach((el) => el.classList.toggle("hide", hidden));
    }

    disable(selector, disabled) {
        this.element.querySelectorAll(selector).forEach((el) => (el.disabled = disabled));
    }
}
